import user from "../../../enums/user";
export default {
  SET_SETTINGS(state, Settings) {
    state.settings = Settings
  },
  SET_INFO_DB(state, payload) {
    state.infoDB = payload
  },
  UPDATE_SETTINGS(state, payload) {
    const index = state.settings.findIndex(setting => setting.id == payload.id);
    state.settings.splice(index, 1)
    state.settings.splice(index, 0, payload)
  }
}